module.exports = __webpack_public_path__ + "img/flag_rect_217.10b5f24b.png";